import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  RadioGroup,
  Radio,
  TableFooter,
  Stack,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import {
  common_locaitonlist_API,
  ORDER_DELIVERY_POST_API,
  ORDER_DETAIL_GETROW_API,
} from "../../Server/ApiV2";
import { Quicksale_Get_Row_Api } from "../../Server/Apis";
import { httpRequest } from "../../Server/Axios";
import { CmpSelectFieldV1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import OrderCard from "./components/OrderCard";
import theme from "../../Theme";
import CirlceCheckbox from "../../Component/Common/ReuseableComponent/CirlceCheckbox";

const OrderDelivery = () => {
  const [fromDate, setFromDate] = useState(moment().subtract(1, "days"));
  const [toDate, setToDate] = useState(moment());
  const [selectedLoc, setSelectedLoc] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [originalTableData, setOriginalTableData] = useState([]); // Backup data

  const [open, setOpen] = useState(false);
  const [paymentMode, setPaymentMode] = useState("cash");
  const [remarks, setRemarks] = useState("");
  const [yesAppRewards, setYesAppRewards] = useState("");
  const [yesAppData, setYesAppData] = useState({
    customerID: "",
    message: "",
    loyaltyId: "",
  });
  const [inputType, setInputType] = useState("Loyalty ID");
  const [isRewardValid, setIsRewardValid] = useState(true);

  const { UserID } = useSelector((state) => state.login.value);
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const imgBaseUrl = vRdxDBKernObj.IMAGE_BASE_URL?.Val;

  const handleYesAppRewardsBlur = async () => {
    if (!yesAppRewards.trim()) return;
    try {
      // Replace with your actual API call logic
      const response = await fetch(
        "http://178.23.187.46:3030/yesApp/memberValidation",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            type: inputType === "Mobile" ? "mobileno" : "loyaltyId",
            location: selectedOrder?.Loc || "",
            data: yesAppRewards,
          }),
        }
      );

      const data = await response.json();

      if (response?.status === 200 && data?.status === "A") {
        setYesAppData((prev) => ({
          ...prev,
          customerID: data?.customerId,
          message: data?.Content || "",
          loyaltyId: data?.loyaltyId,
        }));
        setIsRewardValid(true);
      } else {
        console.error("Error fetching rewards data:", data?.message);
        setIsRewardValid(false);
        fAlertToast("FAILED", "Invalid loyalty ID or mobile number.");
      }
    } catch (error) {
      console.error("API Error:", error);
      setIsRewardValid(false);
      fAlertToast("FAILED", error?.response?.data?.message || "API Error");
    }
  };

  const handleFilter = async () => {
    try {
      if (selectedLoc) {
        const payload = Quicksale_Get_Row_Api({
          StartDate: moment.utc(fromDate).format("MM/DD/YYYY"),
          EndDate: moment.utc(toDate).format("MM/DD/YYYY"),
          PickingStatus: "POST",
          DeliveryStatus: "",
          User: UserID || "",
          Loc: selectedLoc || "",
        });
        let res = await httpRequest(payload);
        if (res?.Type && res?.ResultSet)
          setFilteredOrders(res?.ResultSet || []);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // Fetch data and set both tableData and originalTableData
  const handleOpen = async (order) => {
    setSelectedOrder(order);
    setOpen(true);
    setInputType("Loyalty ID");
    await getTableData(order);
  };
  const getTableData = async (order) => {
    try {
      const response = await ORDER_DETAIL_GETROW_API({ ID: order?.ID || "" });
      const fetchedData = response?.data?.ResultSet || [];
      setTableData(fetchedData);
      setOriginalTableData(JSON.parse(JSON.stringify(fetchedData))); // Deep copy
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // Handle input change
  const handleQtyChange = (value, index) => {
    setTableData((prevData) =>
      prevData.map((item, i) => {
        if (i === index) {
          if (value > item.Qty) {
            fAlertToast(
              "FAILED",
              "Invoice quantity should not be greater then order quantity"
            );
          } else {
            const originalRow = originalTableData[i];
            return {
              ...item,
              InvQty: value,
              InvTaxable: value > 0 ? value * originalRow.RSP : 0,
              TaxAmt:
                value > 0
                  ? value * originalRow.RSP * (originalRow.TaxPerc / 100)
                  : 0,
              NETAmt:
                value > 0
                  ? value * originalRow.RSP +
                    value * originalRow.RSP * (originalRow.TaxPerc / 100)
                  : 0,
            };
          }
        }
        return item;
      })
    );
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrder(null);
    setTableData([]);
    setPaymentMode("cash");
    setRemarks("");
    setInputType("Loyalty ID");
    setYesAppRewards("");
    setYesAppData((prev) => ({
      ...prev,
      customerID: "",
      message: "",
      loyaltyId: "",
    }));
    setIsRewardValid(true);
  };

  const getLocation = useCallback(async () => {
    let locationList = await common_locaitonlist_API({
      usercd: UserID,
    });
    if (locationList?.status === 200) {
      if (locationList.data?.ResultSet?.length > 0) {
        setLocations(locationList?.data?.ResultSet);
        setSelectedLoc(locationList?.data?.ResultSet[0]?.UId);
      }
    }
  }, [UserID]);

  const printReport = async () => {
    try {
      let reportUrl = `${vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val}/Sales/VanSalesStockReport?UserCd=001&Loc=05`;
      console.log("report Url", reportUrl);
      const data = await httpRequest({
        method: "GET",
        url: reportUrl,
      });
      console.log("data", data);
      if (data) {
        localStorage.setItem("tabData", JSON.stringify(data?.Base64Pdf));
        window.open("/preview-pdf", "_blank");
      }
    } catch (error) {
      fAlertToast("FAILED", error?.message);
      console.log(error);
    }
  };

  let debounceTimeout;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      clearTimeout(debounceTimeout);
      handleYesAppRewardsBlur();
    }
  };

  useEffect(() => {
    getLocation();
    handleFilter();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [selectedLoc]);

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          padding: 3,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
          mb: 4,
          mt: 3,
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="From Date"
              value={fromDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setFromDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DatePicker
              label="To Date"
              value={toDate}
              inputFormat="DD/MM/YYYY"
              onChange={(newValue) => setToDate(newValue || moment())}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{
                    height: "35px",
                    "& input": {
                      padding: "9px",
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CmpSelectFieldV1
              xLabelText="locations"
              xValue={selectedLoc}
              xOnChange={(e) => setSelectedLoc(e?.target?.value)}
              xName={"loc"}
              xData={locations ?? []}
              sx={{ height: "100%" }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Button variant="contained" color="primary" onClick={handleFilter}>
              Apply Filters
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Typography variant="pageTitle" color="primary">
        Order Delivery
      </Typography>
      <Box>
        <Grid container spacing={1} mt={1}>
          {filteredOrders?.length > 0 &&
            filteredOrders?.map((order) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                lg={2.4}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", sm: "flex-start" },
                }}
                key={order.ID}
              >
                <OrderCard order={order} handleOpen={handleOpen} />
              </Grid>
            ))}
        </Grid>
      </Box>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            fontWeight: "bolder",
            backgroundColor: "#1976d2",
            color: "#fff",
            padding: 2,
          }}
        >
          {selectedOrder ? `Order ID - ${selectedOrder.ID}` : "Order Details"}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: "#fff",
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Box
              sx={{
                backgroundColor: "#f9f9f9",
                padding: 2,
                borderRadius: 2,
                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Stack direction="row" justifyContent={"space-between"}>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bolder",
                    mb: 1,
                    color: theme.palette.primary.main,
                  }}
                >
                  Order Information
                </Typography>
                <CirlceCheckbox
                  status={selectedOrder?.DeliveryStatus?.toUpperCase()}
                />
              </Stack>
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Order ID
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.ID}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Date
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {moment(selectedOrder?.OrderTime).format("DD-MM-YYYY")}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        User
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.OrderUserName}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car Model
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarModel}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Location
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.LocName}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                {/* Second Column */}
                <Grid item xs={12} sm={6}>
                  <Box display="flex" flexDirection="column" gap={0.5}>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Car No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.CarNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Mobile No
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.MobileNo}
                      </Typography>
                    </Box>
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          flex: "1",
                          fontSize: "0.75rem",
                        }}
                        color="text.secondary"
                      >
                        Delivery Person
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#000",
                          fontWeight: "bold",
                          flex: "1",
                          textAlign: "left",
                          fontSize: "0.75rem",
                        }}
                      >
                        {selectedOrder?.DeliveryPerson}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <TableContainer sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    {[
                      "Image",
                      "Barcode",
                      "Item.Name",
                      "Order.Qty",
                      "Invoice.Qty",
                      "VAT.RSP",
                      // "Tax Amount",
                      // "Tax Percent",
                      "Net.Amount",
                    ].map((heading, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          color: "#000",
                          fontWeight: "bolder",
                          textAlign: "center",
                          padding: "8px !important",
                        }}
                      >
                        {heading}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData?.map((row, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
                      }}
                    >
                      <TableCell
                        align="center"
                        sx={{
                          // fontSize: "0.7rem",
                          // padding: "8px !important",
                          width: "80px !important",
                          height: "80px !important",
                        }}
                      >
                        <img
                          src={`${imgBaseUrl}Products/${row?.SuppRefNo1}.jpg`}
                          alt={row?.ItmCd}
                          loading="lazy"
                          style={{
                            objectFit: "contain",
                            borderRadius: "50%",
                            width: "100%",
                            height: "100%",
                            cursor: "pointer",
                          }}
                        />
                        {/* )} */}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {row.Barcode}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          padding: "8px !important",
                          width: "150px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row.ItmName}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {row.Qty}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        <TextField
                          variant="outlined"
                          size="small"
                          type="number"
                          value={row.InvQty}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            handleQtyChange(value, index);
                          }}
                          inputProps={{
                            style: {
                              textAlign: "center",
                            },
                          }}
                          sx={{
                            width: "100px", // Fixed width
                            "& .MuiInputBase-root": {
                              height: "35px",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {Number(row.VATRSP).toFixed(2)}
                      </TableCell>
                      {/* <TableCell align="center">
                          {Number(row.TaxAmt).toFixed(2)}
                        </TableCell>
                        <TableCell align="center">
                          {Number(row.TaxPerc).toFixed(2)}
                        </TableCell> */}
                      <TableCell
                        align="center"
                        sx={{ padding: "8px !important" }}
                      >
                        {Number(row.NETAmt).toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      align="right"
                      sx={{
                        color: "#000",
                        fontWeight: "bolder",
                        padding: "8px !important",
                      }}
                    >
                      <h5>Total:</h5>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#000",
                        fontWeight: "bolder",
                      }}
                    >
                      <h5>
                        {" "}
                        {tableData
                          ?.reduce((total, row) => total + (row.NETAmt || 0), 0)
                          .toFixed(2)}
                      </h5>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mt: 3,
                padding: 2,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography variant="body1" fontWeight="bold">
                Payment Mode:
              </Typography>
              <RadioGroup
                row
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
              >
                <FormControlLabel
                  value="cash"
                  control={<Radio color="primary" />}
                  label="Cash"
                />
                <FormControlLabel
                  value="card"
                  control={<Radio color="primary" />}
                  label="Card"
                />
              </RadioGroup>
            </Box>
            <Box
              sx={{
                mt: 2,
                p: 2,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
              }}
            >
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Yes Rewards
              </Typography>

              <Box sx={{ mb: 2 }}>
                <Typography variant="body1" fontWeight="bold" gutterBottom>
                  Do you have Yes App Rewards?
                </Typography>

                <RadioGroup
                  row
                  value={inputType}
                  onChange={(e) => setInputType(e.target.value)}
                  sx={{ display: "flex", alignItems: "center", gap: 2 }}
                >
                  <FormControlLabel
                    value="Loyalty ID"
                    control={<Radio />}
                    label="Loyalty ID"
                  />
                  <FormControlLabel
                    value="Mobile"
                    control={<Radio />}
                    label="Mobile"
                  />
                </RadioGroup>
              </Box>

              {inputType && (
                <Box sx={{ mb: 2 }}>
                  <TextField
                    label={`Member ID / Mobile`}
                    value={yesAppRewards}
                    onChange={(e) => setYesAppRewards(e.target.value)}
                    onBlur={handleYesAppRewardsBlur}
                    onKeyDown={handleKeyDown}
                    fullWidth
                    sx={{ backgroundColor: "#fff" }}
                  />
                  {yesAppData?.customerID !== "" && isRewardValid && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="body2"
                        sx={{ color: "green", fontWeight: "bold" }}
                      >
                        Customer ID: {yesAppData?.customerID}
                      </Typography>
                    </Box>
                  )}
                  {!isRewardValid && (
                    <Typography variant="body2" sx={{ color: "red", mt: 1 }}>
                      {yesAppData?.message ||
                        "Invalid loyalty ID or mobile number"}
                    </Typography>
                  )}
                </Box>
              )}
            </Box>{" "}
            <Box sx={{ mt: 2, p: 2, backgroundColor: "#f9f9f9" }}>
              <TextField
                label="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                multiline
                rows={3}
                fullWidth
                sx={{ backgroundColor: "#fff" }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button variant="contained" color="error" onClick={handleClose}>
                Close
              </Button>
              <Button variant="contained" color="primary" onClick={printReport}>
                Print
              </Button>
              <Button
                disabled={
                  selectedOrder?.DeliveryStatus?.toUpperCase() === "POST" ||
                  !isRewardValid
                }
                variant="contained"
                color="info"
                onClick={async () => {
                  try {
                    if (isRewardValid) {
                      // Calculate the sum of InvQty
                      const totalInvQty = tableData.reduce(
                        (sum, item) => sum + (item.InvQty || 0),
                        0
                      );
                      if (totalInvQty <= 0) {
                        // Show an error message if the sum is <= 0
                        fAlertToast(
                          "FAILED",
                          "You cannot post as the sum of invoice quantities is less than or equal to zero."
                        );
                        return;
                      }
                      const payload = {
                        ID: selectedOrder?.ID,
                        User: UserID,
                        Paymode: paymentMode,
                        DeliveryPerson: UserID,
                        DeliveryRemarks: remarks,
                        CustomerSearchinput: yesAppRewards || "",
                        loyaltyId: yesAppData?.loyaltyId || "",
                        Details: tableData.map((item) => ({
                          ItmCd: item.ItmCd,
                          InvQty: item.InvQty || 0,
                          InvTaxable: item.InvTaxable,
                          TaxDept: item.TaxDept,
                          TaxPerc: item.TaxPerc,
                          TaxAmt: item.TaxAmt,
                        })),
                      };
                      const response = await ORDER_DELIVERY_POST_API(
                        fcheck_null_undefine_replace_empty(payload)
                      );
                      if (response?.status === 200) {
                        fAlertToast("SUCCESS", "Order posted successfully!");
                        handleClose();
                        handleFilter();
                      }
                    } else {
                      fAlertToast(
                        "FAILED",
                        "Need to enter loyalty id or mobile number"
                      );
                    }
                  } catch (error) {
                    fAlertToast("FAILED", error?.response?.data?.message);
                  }
                }}
              >
                Post
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OrderDelivery;
